module.exports = __webpack_public_path__ + "img/zhuanli.809e01ac.png";